import React, { createContext, useState } from "react";

const context = createContext(null);

const RecipeContext = ({ children }) => { 
    let [tagsSelected, setTagsSelected] = useState({
        "role": [],
        "industry": [],
        "platforms": [],
        "usecases": [],
    });

    let [recipes, setRecipes] = useState(new Set());
    let [isFilterRecipes, setIsFilterRecipes] = useState(false);
    let [queryParams, setQueryParams] = useState([]);
    let addItem = (item) => {
        setRecipes(recipes.add(item));
        //localStorage.setItem('recipes', JSON.stringify([...recipes]));
    }

  return (
    <context.Provider 
        value={{
            tagsSelected,
            setTagsSelected,
            recipes,
            setRecipes,
            addItem,
            isFilterRecipes,
            setIsFilterRecipes,
            queryParams,
            setQueryParams,
        }}

>
    {children}
</context.Provider>
  );
};

RecipeContext.context = context;

export default RecipeContext;